import { render } from "./FeedbackWidget.vue?vue&type=template&id=708580d6&scoped=true"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js"

import "./FeedbackWidget.vue?vue&type=style&index=0&id=708580d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708580d6"]])

export default __exports__